import { FC } from "react";

import classes from "./GlobalAppLoading.module.css";

const InlineAppLoading: FC = () => {
  return (
    <div className={classes.inlineLoading}>
      <img src="/logo.png" alt="" />
    </div>
  );
};

export default InlineAppLoading;
